"use client";

import {
  AlertTriangle,
  BadgeCheck,
  BookOpenText,
  Building2,
  ClipboardCheck,
  ContactRound,
  DoorOpen,
  Gauge,
  IdCard,
  LogOut,
  MonitorDot,
  ScanLine,
  Settings2,
  ShieldCheck,
  SlidersHorizontal,
  UserRoundCog,
  UsersRound,
} from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

const navigation = [
  {
    label: "Operación",
    items: [
      { label: "Inicio", icon: Gauge, href: "/" },
      { label: "Recepción", icon: ContactRound, href: "/recepcion" },
      { label: "Visitas", icon: BookOpenText, href: "/visitas" },
      { label: "Visitantes", icon: UsersRound, href: "/visitantes" },
      { label: "Anfitriones", icon: IdCard, href: "/anfitriones" },
    ],
  },
  {
    label: "Control de acceso",
    items: [
      { label: "Command Center", icon: MonitorDot, href: "/command-center" },
      { label: "ENTRY / EXIT", icon: ScanLine, href: "/acceso" },
      { label: "Alertas", icon: AlertTriangle, href: "/incidentes" },
      { label: "Reconciliaciones", icon: ClipboardCheck, href: "/reconciliaciones" },
    ],
  },
  {
    label: "Administración",
    items: [
      { label: "Credenciales", icon: BadgeCheck, href: "/credenciales" },
      { label: "Plantas", icon: Building2, href: "/plantas" },
      { label: "Usuarios", icon: UserRoundCog, href: "/usuarios" },
      { label: "Dispositivos", icon: DoorOpen, href: "/dispositivos" },
      { label: "Catálogos", icon: SlidersHorizontal, href: "/catalogos" },
      { label: "Policies", icon: ShieldCheck, href: "/policies" },
      { label: "Configuración", icon: Settings2, href: "/configuracion" },
    ],
  },
];

export function Sidebar({ collapsed }: { collapsed: boolean }) {
  const pathname = usePathname();

  return (
    <aside className="sidebar" data-collapsed={collapsed}>
      <div className="sidebar-brand">
        <Link aria-label="Centelsa Access — Inicio" className={`brand-plate${collapsed ? " brand-plate--compact" : ""}`} href="/">
          <Image
            alt="LaroAccess Centelsa Access"
            height={collapsed ? 34 : 87}
            priority
            src={collapsed ? "/brand/favicon-la.png" : "/brand/logo-la-centelsa.png"}
            width={collapsed ? 34 : 174}
          />
        </Link>
      </div>

      <nav className="sidebar-nav" aria-label="Navegación principal">
        {navigation.map((group) => (
          <div className="nav-group" key={group.label}>
            <span className="nav-label">{group.label}</span>
            {group.items.map(({ href, icon: Icon, label }) => {
              const active = href === "/" ? pathname === "/" : pathname.startsWith(href);
              return (
                <Link
                  aria-current={active ? "page" : undefined}
                  aria-label={collapsed ? label : undefined}
                  className={`nav-item${active ? " nav-item--active" : ""}`}
                  href={href}
                  key={label}
                  title={collapsed ? label : undefined}
                >
                  <Icon aria-hidden="true" />
                  <span>{label}</span>
                </Link>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <div className="sidebar-user">
          <span className="avatar">JD</span>
          <span className="sidebar-user-copy">
            <strong>Julio De La Roche</strong>
            <span>Super administrador</span>
          </span>
          <Link aria-label="Ir a vista de login" className="sidebar-user-action" href="/login" title="Vista de login">
            <LogOut aria-hidden="true" size={17} />
          </Link>
        </div>
      </div>
    </aside>
  );
}
